import React from 'react-router-dom';
import WelcomeBlock from "../common/blocks/WelcomeBlock";
import HomeFacilitesBlock from "../common/blocks/HomeFacilitesBlock";
import CounterBlock from "../common/blocks/CounterBlock";
import TestimonialBlock from "../common/blocks/TestimonialBlock";
import LatestBlogBlock from "../common/blocks/LatestBlogBlock";
import GalleryTabGrid from '../common/gallery/tab_gallery/GalleryTabGrid';
import DataGalleryGridPage from '../common/gallery/tab_gallery/DataGalleryGridPage';
import HomePlatformPlan from "../common/gallery/HomePlatformPlan";
const Home = (props) => {
  return (
   <div>
		<div className="section-full p-t20  p-b70 bg-bottom-center bg-full-width bg-no-repeat">
		{/* <!-- WELCOME SECTION START --> */}
			<WelcomeBlock />
		{/* <!-- WELCOME COMPANY SECTION END --> */}
		</div>
		<div className="section-full bg-gray p-t100 p-b70 bg-repeat">
		{/* <!-- OUR SERVICES SECTION START  --> */}
			<HomeFacilitesBlock />
		{/* <!-- OUR SERVICES SECTION END  --> */} 	
		</div>
		<div className="section-full bg-gray p-t100 bg-repeat">
			{/* <!-- COUNTER CONTENT START --> */}
			<CounterBlock />
			{/* <!-- COUNTER CONTENT END --> */}				
		</div>
		<div className="section-full bg-gray p-t100 bg-repeat">
			{/* <!-- GALLERY CONTENT START --> */}
			<GalleryTabGrid demoData={DataGalleryGridPage} />
			{/* <!-- GALLERY CONTENT END --> */}
		</div>
		<div className="section-full bg-white">
			{/* <!-- GALLERY CONTENT START --> */}
			<HomePlatformPlan />
			{/* <!-- GALLERY CONTENT END --> */}
		</div>
		<div className="section-full bg-gray bg-repeat">
			{/* <!-- TESTIMONIALS CONTENT START --> */}
			<TestimonialBlock />
			{/* <!-- TESTIMONIALS CONTENT END --> */}
		</div>
		
		<div className="section-full latest-blog bg-gray p-t100 p-b70">
			{/* <!-- BLOG CONTENT START --> */}
			<LatestBlogBlock />
			{/* <!-- BLOG CONTENT END --> */}
		</div>				
  </div>
  );
};
Home.defaultProps = {
    radius:"radius",
}
export default Home;